function removeCurrentClass(arr) {
  arr.forEach(element => {
    element.classList.remove('current');
  });
}

function filterModeClick(el, arr, modeEl) {
  el.addEventListener('click', (e) => {
    removeCurrentClass(arr);
    el.classList.add('current');
    modeEl.dataset.mode = el.dataset.mode;
  });
}
window.addEventListener("load", (e) => {
  let filterByEl = document.getElementById("jsFilterBy");
  if (filterByEl) {
    $('#jsFilterBy').select2({
      placeholder: "Choose"
    });
  }
  
  let sortByEl = document.getElementById("jsSortBy");
  if (sortByEl) {
    $('#jsSortBy').select2({
      placeholder: "Choose"
    });
  }

  let viewModeEls = document.querySelectorAll('.jsViewMode'),
  modeEl = document.getElementById('jsMode');
  if(viewModeEls && modeEl) {
    viewModeEls.forEach(filterModeEl => {
      filterModeClick(filterModeEl, viewModeEls, modeEl);
    });
  }
});
